module.exports = __webpack_public_path__ + "media/usecase_enterprise_02.609b8ace.mp4";